/**
 * Standardized form style constants for consistent UI across the application
 */

/**
 * Standard form container styling
 * Used for auth forms, contact forms, etc.
 */
export const FORM_CONTAINER_SX = {
  mt: 8,
  p: 4,
  boxShadow: 3,
  borderRadius: 2,
};

/**
 * Standard snackbar position
 * Consistent bottom-center positioning across all forms
 */
export const SNACKBAR_POSITION = {
  vertical: 'bottom',
  horizontal: 'center',
};

/**
 * Form field margin options
 */
export const FORM_FIELD_MARGIN = 'normal';

/**
 * Standard button styling for forms
 */
export const FORM_BUTTON_SX = {
  mt: 2,
  mb: 1,
};

/**
 * Dialog form styling
 */
export const DIALOG_FORM_SX = {
  mt: 1,
  mb: 2,
};

/**
 * Loading container styling for centered spinners
 */
export const LOADING_CONTAINER_SX = {
  textAlign: 'center',
  mt: 8,
};

const formStyles = {
  FORM_CONTAINER_SX,
  SNACKBAR_POSITION,
  FORM_FIELD_MARGIN,
  FORM_BUTTON_SX,
  DIALOG_FORM_SX,
  LOADING_CONTAINER_SX,
};

export default formStyles;
